// 问卷库模块
export default {
    QuesLibrary: {
        QuestionnaireType: '问卷类型',
        TemplatSistem: '系统模板',
        TemplatSaya: '我的模板',
        BankSoalanSaya: '我的题库',
        BankSoalanSistem: '系统题库',
        QuestionBankAnalysis: '题库分析',
        LabelMasalah: '问题标签',
        PengurusanMasalah: '问题管理',
        Tambah: '添加',
        Name: '名称',
        SortOrder: '排序顺序',
        Operate: '操作',
        AreYouSureToDeleteIt: '确定删除吗？',
        Delete: '删除',
        Edit: '编辑',
        NewlyAdded: '新增',
        ModifySortingPosition: '修改排序位置',
        Category: '所属分类',
        SortPosition: '排序位置',
        PleaseEnterAName: '请输入名称',
        SelectCategory: '选择所属分类',
        PleaseSelectCategory: '请选择所属分类',
        All: '全部',
        QuestionnaireName: '问卷名称',
        NumberOfCitations: '引用次数',
        Type: '所属类型',
        DesignQuestionnaire: '设计问卷',
        Preview: '预览',
        Modify: '修改',
        MyTemplate: '我的模板',
        CannotExceed5MB: '上传文件大小不能超过 5MB，请重新选择图片！',
        PleaseUploadPictures: '请上传图片',
        QuestionBankList: '题库列表',
        NumberOfRecords: '记录条数',
        Refresh: '刷新',
        SearchQuestionBankName: '请输入要搜索的题库名称',
        SearchQuestionBankCategories: '请输入要搜索的题库类别',
        Query: '查询',
        CreateANewQuestionBank: '新建题库',
        QuestionBankNumber: '题库编号',
        None: '暂无',
        QuestionBankName: '题库名称',
        QuestionBankCategory: '题库类别',
        Creator: '创建人',
        NumberOfTestQuestions: '试题数',
        Memo: '备注信息',
        CreateQuestion: '创建问题',
        EditQuestion: '编辑问题',
        EditQuestionBank: '编辑题库',
        AddQuestionBank: '添加题库',
        QuestionBankInfo: '题库信息',
        ConfirmDeletionOfQuestionBank: '确定删除该题库吗？',
        SelectTheQuestionBankToDelete: '请先选择要删除的题库',
        DeletSelectedQuestionBank: '确定删除已选中的题库吗?',
        CancelTheSelectedQuestionBank: '确定取消已选中的题库吗？',
        CancelFavorite: '取消收藏',
        Prompt: '提示',
        ChooseAQuestionBankToBookmark: '请先选择要收藏的题库',
        CanceledSuccessfully: '取消成功',
        QuestionBankNumberLimit: '1-32个字符，使用字母、数字、下划线',
        EnterOrSelectArticleLabel: '输入/选择文章标签',
        Notes: '备注',
        Save: '保存',
        Resetting: '重置',
        CharacterMismatch: '请使用字母、数字、下划线',
        LengthMismatch: '长度在 1 到 32 个字符',
        EnterTheNameOfTheQuestionBank: '请输入题库名称',
        EnterQuestionBankCategory: '请输入题库类别',
        EnterQuestionBankNotes: '请输入题库备注',
        SelfBuiltQuestionBank: '自建题库',
        DeleteQuestionBankFromFavoritesList: '确定从收藏列表删除该题库吗？',
        ChooseToCancelTheFavoriteQuestionBank: '请先选择要取消收藏的题库',
        QuestionLabelName: '问题标签名称',
        AddQuestionLabel: '添加问题标签',
        TagName: '标签名称',
        ModifyProblemLabels: '修改问题标签',
        DeleteTitleTip: '删除后将删除分组内所有题目',
        DeleteConfirmation: '删除确认',
        ExportData: '导出数据',
        NumberOfRespondents: '回答人数',
        NumberOfRespondents: '答题人数',
        Download: '下载',
        LoadMore: '加载更多',
        ModificationPrompt: '修改提示',
        ConfirmModifyingTheQuestionnaire: '您确认修改此问卷吗？该问卷所有数据收集将被停止，答卷链接暂时关闭！',
        DataType: '数据类型',
        RawData: '原始数据',
        CodedData: '编码数据',
        ExhibitionFormat: '展出形式',
        OneQuestionOneColumn: '一题一列',
        OneQuestionWithMultipleColumns: '一题多列',
        Export: '导 出',
        CustomTitle: '自定义标题',
        Pie: '饼图',
        Histogram: '柱状图',
        BarChart: '条形图',
        Ring: '圆环',
        StackedBarChart: '堆积柱状图',
        StackedBarChart2: '堆积条形图',
        RadarChart: '雷达图',
        ProblemList: '问题列表',
        MultipleChoiceBank: '请选择题库',
        EnterQuestionName: '请输入问题名称',
        EnterQuestionnaireLabel: '请输入问卷标签',
        ConfirmDeletionSelectedIssues: '确定删除已选中的问题吗？',
        IssueNames: '问题名称',
        AffiliatedQuestionBank: '所属题库',
        QuestionnaireLabel: '问卷标签',
        AreYouSureToDeleteTheIssue: '确定删除该问题吗？',
        Easy: '易',
        Easier: '较易',
        Middle: '中',
        RelativelyDifficult: '较难',
        Difficult: '难',
        NoLimit: '不限',
        Radio: '单选',
        SelectTheQuestionToDelete: '请先选择要删除的问题',
        TestQuestionManagement: '试题管理',
        EditItem: '编辑试题',
        Success: '成功'
    },
  };